import {Component, Inject, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { select, Store } from '@ngrx/store';
import { AuswertungState } from '../../store/reducer/auswertungen.reducer';
import {AuswertungenStufenComponent} from '../auswertungen-stufen/auswertungen-stufen.component';
import {NodeItem} from '../../../projektverwaltung/node.model';
import { Observable } from 'rxjs';
import {MatRadioModule} from '@angular/material/radio';
import {getFilteredZeitStarted} from '../../store/actions/filter-seek-date.actions';
import {loadProjektauswahlNodesStart} from '../../store/actions/getProjektauswahlNodes.actions';
import {ProjektState} from '../../../projektverwaltung/store/reducer/projektverwaltung.reducer';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {Security} from '../../../../security';
import {loadProjektSelectboxStart} from '../../../Zeiterfassung/store/actions/project-selectbox.actions';
import {DashboardItem} from '../../../landingpage/dashboard.model';
import {Zeitstate} from '../../../Zeiterfassung/store/reducer/zeiterfassung.reducer';
import {loadCacheStart} from '../../../Zeiterfassung/store/actions/getCacheNodes.actions';
import {map} from 'rxjs/operators';
import {BreakpointObserver} from '@angular/cdk/layout';


/* Projekt Auswahl */
export interface ProjektDaten {
  prjID: number;
  prjName?: string;
  prjPRJ?: number;
  prjLevel?: number;
}

/* Ende Projekt Auswahl */

export interface DialogData {
  id: number;
  title: string;
  spesenTitle: string;
  submitButtonLabel: string;
  datum: Date;
  start: Date;
  ende: Date;
  dauerIntern: string;
  dauerExtern: string;
  text: string;
  verrechnen: any;
  verrechnet: any;
  niverbar: any;
  projekt: string;
  projektstufe0: string;
  letzteProjektstufe: string;
  cancelButtonLabel: string;
  spesenTotal: number;
  deletable: boolean;
}

@Component({
  selector: 'app-auswertungen-formdialog-neu',
  templateUrl: './auswertungen-formdialog-neu.component.html',
  styleUrls: ['./auswertungen-formdialog-neu.component.scss'],
})

export class AuswertungenFormdialogNeuComponent implements OnInit {

  /* Ende Projekt Auswahl */
  constructor(public dialogRef: MatDialogRef<AuswertungenFormdialogNeuComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              public fB: FormBuilder,
              public dialog: MatDialog,
              public store: Store<{ zeiterfassung: AuswertungState }>,
              public projektverwaltung: Store<{ projektverwaltung: ProjektState }>,
              public zeiterfassung: Store<{zeiterfassung: Zeitstate}>,
              public http: HttpClient,
              public router: Router,
              public security: Security,
              private breakpointObserver: BreakpointObserver
  )
  {
    dialogRef.disableClose = true;
    this.$projektSelectbox = store.pipe(select((state) => state.zeiterfassung.selectboxProjekte));
    this.$cache = zeiterfassung.pipe(select((state) => state.zeiterfassung.cacheNodes));
    /* Gridwerte in die Bearbeiten Maske hineinschreiben */
    this.auswertungForm.patchValue({
      start: this.wandler(data.start),
      ende: this.wandler(data.ende),
      alleBenutzer: false,
      benutzer: false,
      offen: parseInt(data.verrechnen, 10),
      showZeit: true,
      showSpesen: false,
      zeitAuswahl: '1',
      spesenAuswahl: '1',
      zwischensummen: true,
      separat: false,
      details: true,
      projekt: data.projekt,
      projektstufe0: data.projektstufe0,
      letzteProjektstufe: data.letzteProjektstufe,
    });


  }
  public isSmallDevice = false;
  @ViewChild(AuswertungenStufenComponent) stufe;
  public showAlleBenutzer: Observable<boolean>;
  public $cache: Observable<DashboardItem[]>;
  public disableProjektstufe: boolean;
  public isDisabled = false;
  public showingStufen: number[];
  public $projektSelectbox: Observable<NodeItem[]>;
  public dauerPattern = '^([0-9]{1,2}\\.)+[0-9]{1,2}$';
  /* Speichert die Werte des Formulars */
  public auswertungForm = new FormGroup({
    zeitAuswahl: new FormControl(''),
    spesenAuswahl: new FormControl({value: '0', disabled: true}),
    start: new FormControl(''),
    ende: new FormControl(''),
    details: new FormControl(''),
    alleBenutzer: new FormControl(''),
    benutzer: new FormControl(''),
    zwischensummen: new FormControl(''),
    offen: new FormControl(''),
    showZeit: new FormControl(''),
    showSpesen: new FormControl(''),
    cache: new FormControl(''),
    ferien: new FormControl(''),
    separat: new FormControl('')
    });

  /* Zuweisen der Werte vom Kind in die Variable daten */
  daten;

  public getErrorMessage(Feld: string): string {
    const formControl = this.auswertungForm.get(Feld);
    if (formControl.hasError('required')){
      return`pages.timeDialog.formValidation.error.${Feld}.required`;
    }
    return 'pages.timeDialog.formValidation.error.generic';
  }

  /* Ende Checkbox 3 */

  /* Wandelt Datum um: Ohne Zeitzone und im richtigen Backendformat */
  public wandler(date: any): any {
    const dwD = date.toLocaleString( 'en-US', { timezone: 'utc' } );
    return moment(dwD).format('YYYY-MM-DD');
  }

  // tslint:disable-next-line:typedef use-lifecycle-interface
  ngAfterViewInit() {
    this.daten = this.stufe.addButtonForm;
  }

  /* Ende Zuweisen der Werte vom Kind in die Variable daten */

  public ngOnInit(): void {
    this.breakpointObserver
      .observe(localStorage.getItem('phoneWidth'))
      .pipe(map((result) => result.matches))
      .subscribe((isSmallDevice) => {
        this.isSmallDevice = isSmallDevice;
      });

    this.showAlleBenutzer = this.security.checkIfAllowed('3001');
    this.store.dispatch(loadProjektauswahlNodesStart());
    this.store.dispatch(loadCacheStart());
  }

  public handleSubmitClick(): void {
    this.auswertungForm.value.start = this.wandler(this.auswertungForm.value.start);
    this.auswertungForm.value.ende = this.wandler(this.auswertungForm.value.ende);

    const item = this.auswertungForm.value;
    item.id = this.data.id;
    item.projektstufe0 = this.daten.value.projektstufe0;
    // get highest projektstufe
    item.letzteProjektstufe = this.getLastProjektstufe();
    this.auswertungForm.value.dontShowStufen = this.showingStufen;
    if (!this.auswertungForm.value.showZeit){
      this.auswertungForm.value.zeitAuswahl = 0;
    }
    if (!this.auswertungForm.value.showSpesen){
      this.auswertungForm.value.spesenAuswahl = 0;
    }
    console.log(this.auswertungForm.value);
    // suche alle Zeiten für Auswertung
    // this.store.dispatch(getFilteredZeitStarted({item: this.auswertungForm.value }));
    this.dialogRef.close(this.auswertungForm.value);
  }

  /* Abbruchfunktion */
  // tslint:disable-next-line:typedef
  public handleCancelClick() {
    this.dialogRef.close(false);
  }
  /* holt die letzteProjektstufe */
  public getLastProjektstufe(): NodeItem{
    const dontShowStufen = [];
    // tslint:disable-next-line:prefer-const
    let showStufe;
    let projektStufe;
    let letzteStufe;
    for (let i = 0; i < 1000; i++){
      let testString = 'projektStufe = this.daten.value.projektstufe' + i;
      // tslint:disable-next-line:no-eval
      eval(testString);
      testString = 'showStufe = this.daten.value.showStufe' + i;
      // tslint:disable-next-line:no-eval
      eval(testString);
      dontShowStufen.push(showStufe);
      if (projektStufe?.children?.length === 0){
        letzteStufe = projektStufe;
        this.showingStufen = dontShowStufen;
        return letzteStufe;
      }
      else if (projektStufe !== undefined && projektStufe !== ''){
        letzteStufe = projektStufe;
      }
      else{
        this.showingStufen = dontShowStufen;
        return letzteStufe;
      }
    }
  }

  public checkZeitauswahl(isChecked: boolean): void{
    if ( !isChecked){
      this.auswertungForm.get('zeitAuswahl').disable();
    }
    else{
      this.auswertungForm.get('zeitAuswahl').enable();
    }
  }

  public checkSpesenauswahl(isChecked: boolean): void{
    if ( !isChecked){
      this.auswertungForm.get('spesenAuswahl').disable();
    }
    else{
      this.auswertungForm.get('spesenAuswahl').enable();
    }
  }

  public selectProjects(projektId: number): void {
    this.store.dispatch(loadProjektSelectboxStart({projektId}));
  }

  public setProjektstufeDisabled(checked: boolean): void{
    this.disableProjektstufe = checked;
    if(checked){
      this.auswertungForm.get('cache').disable();
    }
    else{
      this.auswertungForm.get('cache').enable();
    }
  }

}

